import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken,removeToken, getUserLanguage } from '@/utils/auth' // getToken from cookie
import i18n from './lang'
// import Layout from '@/views/layout'
// const immutable = require('immutable')
NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login', '/500','/404' ,'/auth-redirect','/toyotaAgreement']// no redirect whitelist
// 此处全部转为2级菜单缓存
function getNewAddRouters(data,parentItem){
  data.forEach((item)=>{
    // debugger;
    if(item.children && item.children.length){
      if(item.level===2){
        for(let i= 0;i<item.children.length;i++){
          parentItem.children=[...parentItem.children,...[item.children[i]]]
        }
        const index = parentItem.children.findIndex(v=>v.name===item.name)
          if(index>-1){
            parentItem.children.splice(index,1)
          }
      }
      getNewAddRouters(item.children,item)
    }
  })
}

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else if (to.path === '/500') {
      next()
      NProgress.done()
    } 
    else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('getUserInfo').then((e) => { // 拉取user_info
          // 后台返回数据有时会出现无data问题导致一直请求
          if(!e.data){
            removeToken()
            next(`/login?redirect=${to.path}`)
            return
          }
          // 动态拉取路由表
          const p1 = store.dispatch('app/load')
          const p2 = store.dispatch('generateRoutes')
          Promise.all([p1, p2]).then(() => {
              router.app.$ELEMENT.size = store.state.app.size
              const pageLeftRouter = JSON.parse(JSON.stringify(store.getters.addRouters))
              // 缓存页面左侧栏数据
              store.dispatch('generateRealRoutes',pageLeftRouter)
              // 获取新的数据
              let realAddRoutes = [...store.getters.addRouters]
              getNewAddRouters(realAddRoutes,realAddRoutes[0])
            
              router.addRoutes(realAddRoutes)
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            // else {
            //   store.dispatch('logout').then(() => {
            //     next({ path: '/' })
            //   })
            // }
          }).catch(()=>{

          })
          // todo: 先在这里分发一下
          store.dispatch('loadAreas')
          store.dispatch('loadModels')
          store.dispatch('loadFuels')
        }).catch((err) => {
          store.dispatch('logout').then(() => {
            Message.error(err || i18n.t('public.resMsg'))
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } 
  else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
  store.commit('app/setLanguage', getUserLanguage())
  i18n.locale = getUserLanguage()
  document.title = i18n.t('public.pageTitle')
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
